import React from 'react';
import PropTypes from 'prop-types';
import { FontSize } from '@common/tokens';

export default function OnboardingListTemplateField({ value }) {
  return (
    <>
      <td className="onboarding-list-template-field text-heavy">{value}</td>
      <style jsx>{`
        .onboarding-list-template-field {
          font-size: ${FontSize.md};
        }
      `}</style>
    </>
  );
}

OnboardingListTemplateField.propTypes = {
  value: PropTypes.node.isRequired,
};
